import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { apiFetch, safeArray } from "../utils/api";
import { apiBase } from "../lib/apiBase";

export default function LiveTradeVisualizer({ coin, onClose }) {
    const [trades, setTrades] = useState([]);

    useEffect(() => {
        if (!coin) return;
        apiFetch(apiBase(`trade_log?limit=500`))
            .then((data) => {
                const filtered = safeArray(data).filter(
                    (t) => t.coin && t.coin.toLowerCase() === coin.toLowerCase(),
                );
                setTrades(filtered);
            })
            .catch(() => setTrades([]));
    }, [coin]);

    return (
        <div className="bg-gray-800 rounded p-4">
            <div className="flex justify-between items-center mb-2">
                <h3 className="font-semibold text-sm">{coin} Trades</h3>
                {onClose && (
                    <button
                        type="button"
                        className="text-xs text-blue-400"
                        onClick={onClose}
                    >
                        Close
                    </button>
                )}
            </div>
            <div className="h-48 overflow-y-auto text-xs">
                {trades.length === 0 ? (
                    <div className="text-gray-400">No data yet</div>
                ) : (
                    trades.map((t, i) => (
                        <div
                            key={i}
                            className={
                                t.roi > 0
                                    ? "text-green-400"
                                    : t.roi < 0
                                    ? "text-red-400"
                                    : "text-gray-400"
                            }
                        >
                            {t.timestamp} @ {t.price} ({
                                t.roi !== undefined && t.roi !== null
                                    ? `${t.roi.toFixed ? t.roi.toFixed(2) : t.roi}%`
                                    : "n/a"
                            })
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

LiveTradeVisualizer.propTypes = {
    coin: PropTypes.string.isRequired,
    onClose: PropTypes.func,
};

LiveTradeVisualizer.defaultProps = {
    onClose: null,
};
